<template>
  <div class="standard_main_container">
    <h2>404</h2>
    <h2>Page not found</h2>
  </div>
</template>

<style lang="scss" scoped>

h2 {
  margin: min(20vh, 160px) auto;
  text-align: center;
}
h2:nth-child(2) {
  margin-bottom: min(40vh, 320px);
}
</style>